/**
 * 拼单购物车商品
 */
import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { cartMobx, orderMobx } from 'restaurant'
import { multiPersonMobx } from '@mobxStore'
import ProductItem from './ProductItem'
import './index.scss'

interface IProps {
  handleOutCart: () => void;
}

const BTCartItem: React.FC<IProps> = (props) => {
  const [listMap, setListMap] = useState<{[key: string]: any}>({})
  const { handleOutCart } = props

  const getOrderMap = () => {
    let map = {}
    orderMobx.order.detailList.forEach((item) => {
      if (['product', 'FixedCombo', 'OptionalCombo'].includes(item.itemType)) {
        const picsIndex = orderMobx.order.picsProduct?.indexOf(item.productNo)
        let pic = ''
        const picString = (orderMobx.order.pics || [])[picsIndex]
        try {
          const picInfo = JSON.parse(picString)
          pic = picInfo?.[0]?.url || ''
        } catch (e) {
          pic = picString || ''
        }
        const newItem = {
          ...item,
          pic
        }
        map[item.addUserId] ? map[item.addUserId].push(newItem) : (map[item.addUserId] = [newItem])
      }
    })
    return map
  }

  useEffect(() => {
    setListMap(orderMobx.order.ordersId ? getOrderMap() : cartMobx.viewUserCartItems)
  }, [multiPersonMobx.multiPersonMap, orderMobx.order, cartMobx.viewUserCartItems])
  return (
    <div className='btcart-item-container'>
      <div className='btcart-person-box'>
        {multiPersonMobx.currentPersonInfo.personId && <ProductItem key={multiPersonMobx.currentPersonInfo.personId} handleOutCart={handleOutCart} user={multiPersonMobx.currentPersonInfo.personId} list={(listMap[multiPersonMobx.currentPersonInfo.personId] || []).filter(item => !item.disabled)} isSelf />}
        {
          Object.keys(multiPersonMobx.multiPersonMap).map(user => {
            if (user !== multiPersonMobx.currentPersonInfo.personId) {
              const list = (listMap[user] || []).filter(item => !item.disabled)
              return <ProductItem key={user} user={user} list={list} />
            }
          })
        }
      </div>
    </div>
  )
}

export default observer(BTCartItem)
